import { output } from '@/helpers/std-out'
import type { OpenAPI } from '@scalar/openapi-types'

import as from 'ansis'

export const printSpecificationBanner = (result: {
  version?: string
  schema?: OpenAPI.Document
}) => {
  const { version, schema } = result

  if (!schema?.info?.title || !version) {
    return
  }

  // Count number of paths
  const pathsCount = Object.keys(schema.paths ?? {}).length

  // Count number of operations
  const operationsCount = Object.values(schema.paths ?? {}).reduce(
    (acc: number, path) => acc + Object.keys(path).length,
    0,
  )

  output
    .info()
    .title(
      `${as.white.bold(schema?.info?.title)} ${as.grey(`(OpenAPI v${version})`)}`,
    )
    // Statistics
    .title(as.grey(`${pathsCount} paths, ${operationsCount} operations`))
    .print()
}
